import { gql } from '@apollo/client';

// types + resolvers for apollo cache
export const typeDefs = gql`
    type Query {
        reSignIn: Boolean!
    }
`;
